import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';

import { StatusBarItem } from './StatusBarItem.view';

import type { StatusBarTask } from '../../types/common.types';
import { StatusBarItems } from './StatusBarItems.views';

const useStyle = makeStyles(() => {
  return {
    statusBar: {
      width: '100%',
      position: 'absolute',
      bottom: '1rem',
      // @ts-ignore
      left: (props) => (props.collapsed ? '1rem' : 0),
    },
  };
});

export const StatusBar: React.FC<{
  isAnyTaskRunning: boolean;
  collapsed: boolean;
  tasks: StatusBarTask[];
}> = ({ collapsed = false, isAnyTaskRunning, tasks }) => {
  const classes = useStyle({ collapsed });

  return (
    <div className={classes.statusBar}>
      {collapsed ? (
        isAnyTaskRunning && (
          <CircularProgress
            color="secondary"
            size={25}
            disableShrink={true}
            title="Tasks running"
          />
        )
      ) : (
        <StatusBarItems tasks={tasks} collapsed={collapsed} />
      )}
    </div>
  );
};
